import { createFileRoute, redirect } from '@tanstack/react-router'

const SUPPORTED_LOCALES = ['es', 'gl', 'en', 'de', 'fr', 'it', 'nl', 'pt']

export const Route = createFileRoute('/$locale/dashboard')({
  ssr: false, // Dashboard is authenticated, no SEO needed - CSR only
  beforeLoad: ({ params }) => {
    if (!SUPPORTED_LOCALES.includes(params.locale)) {
      throw redirect({ to: '/$locale/dashboard/overview', params: { locale: params.locale }, replace: true })
    }
  },
})
